<template>
  <div>
    <v-container grid-list-xl fluid>
      <table-payout-address coin="ADA"></table-payout-address>
    </v-container>
  </div>
</template>

<script>
import TablePayoutAddress from "@/components/table/TablePayoutAddress";

export default {
  name: "PayoutCardanoList",
  components: {
    TablePayoutAddress
  }
};
</script>

<style scoped></style>
